import React from 'react';

import { Text } from './UIKit/system';
import styled, { css } from 'styled-components';
import Separator from './separator-vertical';
import mq from '../utils/mq';

const StyledTitleWithSeparator = styled.div`
  display: flex;
  align-items: center;

  ${(props) =>
    props.split &&
    mq.mobile(css`
      flex-wrap: wrap;
    `)}
`;

const TopLayer = styled.div`
  display: flex;
  align-items: center;

  ${(props) =>
    props.split &&
    mq.mobile(css`
      width: 100%;
      margin-bottom: 2.5px;
    `)};
`;

const BottomLayer = styled.div`
  display: flex;
`;

const TitleText = styled(Text)`
  color: #161616;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0px;
`;

const SubtitleText = styled(Text)`
  color: var(--Foreground-fg-secondary, #565656);
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
`;

function TitleWithSeparator(props) {
  const { title, subtitle, large, split, swapStyling, flipTitleAndSubtitle } =
    props;
  const fontSize = [16, 18, 20];

  if (flipTitleAndSubtitle) {
    return (
      <StyledTitleWithSeparator split={split}>
        <TopLayer split={split}>
          <SubtitleText
            color={'#959595'}
            fontSize={fontSize}
            fontSizeExtraLarge={large}
          >
            {subtitle}
          </SubtitleText>
          {subtitle && title && <Separator mx={7} />}{' '}
        </TopLayer>
        <BottomLayer>
          <TitleText
            fontSize={fontSize}
            fontSizeExtraLarge={large}
            color={'#161616'}
            bold
          >
            {title}
          </TitleText>
        </BottomLayer>
      </StyledTitleWithSeparator>
    );
  }

  return (
    <StyledTitleWithSeparator split={split}>
      <TopLayer split={split}>
        <TitleText
          fontSize={fontSize}
          fontSizeExtraLarge={large}
          color={swapStyling ? 'grey7' : 'black'}
          bold={!swapStyling}
        >
          {title}
        </TitleText>
        {subtitle && title && <Separator mx={7} />}{' '}
      </TopLayer>
      <BottomLayer>
        <Text
          color={swapStyling ? 'black' : 'grey7'}
          bold={swapStyling}
          fontSize={fontSize}
          fontSizeExtraLarge={large}
        >
          {subtitle}
        </Text>
      </BottomLayer>
    </StyledTitleWithSeparator>
  );
}

export default TitleWithSeparator;
